import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spinner, Container, Row, Col } from 'reactstrap';

const OAuthCallback = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const accessToken = searchParams.get('access_token');
        const refreshToken = searchParams.get('refresh_token');
        const error = searchParams.get('error');

        if (error) {
            console.error('OAuth error:', error);
            navigate('/login');
            return;
        }

        if (accessToken && refreshToken) {
            localStorage.setItem('access_token', accessToken);
            localStorage.setItem('refresh_token', refreshToken);
            navigate('/campaign');
        } else {
            navigate('/login');
        }
    }, [searchParams, navigate]);

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <Row>
                <Col className="text-center">
                    <Spinner color="primary" />
                    <div className="mt-3">
                        <span>Processando autenticação...</span>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default OAuthCallback;